import * as React from "react";
import { IdStyles } from "../../less/IdStyles";
import { Badge } from "../generic/badge/Badge";
import { IdBadgePosition } from "../generic/badge/IdBadgePosition";
import { Icon } from "../generic/icon/Icon";
import { IdIcon } from "../generic/icon/IdIcon";
import { NumberFormat } from "../generic/number-format/NumberFormat";
import { ProfilePicture } from "../player-profile/ProfilePicture";
export var MessageProfileInfo = React.memo(function (_a) {
    var messageInfo = _a.messageInfo;
    var playerLevel = messageInfo.playerLevel, profileIcon = messageInfo.profileIcon;
    return (React.createElement("div", { className: "chat-picture-container" },
        React.createElement(ProfilePicture, { profilePictureName: profileIcon, profilePictureSize: IdStyles.ProfilePictureSmall }),
        React.createElement(Badge, { position: IdBadgePosition.BottomCenter },
            React.createElement(Icon, { icon: IdIcon.XpIcn, styleId: IdStyles.IconSmall },
                React.createElement("div", { className: "flex flex--guts h100" },
                    React.createElement(NumberFormat, { amount: playerLevel, className: IdStyles.TextSmallBoldSecondaryOutline }))))));
});



//////////////////
// WEBPACK FOOTER
// ./src/features/chat/MessageProfileInfo.tsx
// module id = 915
// module chunks = 3